import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 800 800">
    <title>Logo</title>
    <rect x="120" y="200" width="90" height="400" fill="currentColor" />
    <polygon points="260,600 420,200 520,200 360,600" fill="currentColor" />
    <polygon points="430,600 520,420 560,420 470,600" fill="currentColor" />
    <rect x="600" y="200" width="90" height="400" fill="currentColor" />
  </svg>
);

export default IconLogo;
